import { Button } from '@quadralize/ui'
import { DangerCircle, Refresh } from '@solar-icons/react'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { useRouteError } from 'react-router-dom'
import { env } from '@/config/env'
import { ErrorLayout } from '../components/error-layout'

export function GenericError() {
  const { t } = useTranslation('error')
  const error = useRouteError()
  const errorMessage = error instanceof Error ? error.message : t('generic.fallbackMessage')

  const blobs = [
    {
      id: 'blob-1',
      color: 'bg-destructive/10',
      size: 'w-48 h-48 md:w-80 md:h-80',
      top: '-5%',
      right: '-5%',
      delay: 0,
    },
    {
      id: 'blob-2',
      color: 'bg-orange-500/10',
      size: 'w-56 h-56 md:w-96 md:h-96',
      bottom: '-10%',
      left: '-5%',
      delay: 2,
    },
  ]

  return (
    <>
      <ErrorLayout
        code={t('generic.code')}
        title={t('generic.title')}
        description={t('generic.description')}
        icon={<DangerCircle />}
        errorCode={t('generic.errorCode')}
        blobs={blobs}
        showHomeButton={false}
        actions={
          <Button
            onClick={() => window.location.reload()}
            size="lg"
            startIcon={<Refresh className="w-5 h-5" />}
          >
            {t('generic.reload')}
          </Button>
        }
      />

      {env.DEV && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1 }}
          className="fixed bottom-4 left-4 right-4 md:left-auto md:right-8 md:bottom-8 z-50 max-w-md w-full mx-auto md:mx-0 p-4 rounded-xl bg-background/80 backdrop-blur border border-destructive/20 shadow-lg"
        >
          <h3 className="text-xs font-bold text-destructive uppercase tracking-wider mb-2 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-destructive animate-pulse" />
            {t('generic.detailsTitle')}
          </h3>
          <code className="text-xs font-mono text-muted-foreground break-all">{errorMessage}</code>
        </motion.div>
      )}
    </>
  )
}
